<template>
    <b-modal
        id="show-main-group-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        title="Stamgroep overzicht"
        size="md"
        ok-only
        :ok-title="$t('common.close')">
        Docent(en):
        <span
            v-for="employee in lasEmployees"
            :key="employee.id"
            >{{ employee.user.full_name }}, </span
        ><br /><br />
        Leerlingen:
        <design-2021-apprentice-data-table
            :items="lasStudents"
            :fields="field">
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-las-main-group-modal-component',
    data() {
        return {
            modal: false,
            lasMainGroup: null,
            lasStudents: [],
            lasEmployees: [],
            field: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
            ],
        };
    },
    methods: {
        show(lasMainGroup) {
            this.lasMainGroup = lasMainGroup;
            this.axios.get(this.routes.getLasMainGroupInfo(lasMainGroup.id)).then(
                (response) => {
                    this.lasStudents = response.data.students;
                    this.lasEmployees = response.data.employees;
                    this.modal = true;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
